import api from 'utils/api'
import {
  FETCH_SALES_EVENTS_FAILED,
  FETCH_SALES_EVENTS_REQUESTED,
  FETCH_SALES_EVENTS_SUCCEDED,
  CREATE_SALES_EVENTS_FAILED,
  CREATE_SALES_EVENTS_REQUESTED,
  CREATE_SALES_EVENTS_SUCCEDED,
  UPDATE_SALES_EVENTS_FAILED,
  UPDATE_SALES_EVENTS_REQUESTED,
  UPDATE_SALES_EVENTS_SUCCEDED,
} from './constants'

export const fetchSalesEventsRequested = () => ({
  type: FETCH_SALES_EVENTS_REQUESTED,
})

export const fetchSalesEventsSucceded = (payload) => ({
  type: FETCH_SALES_EVENTS_SUCCEDED,
  payload,
})

export const fetchSalesEventsFailed = () => ({
  type: FETCH_SALES_EVENTS_FAILED,
})

export const fetchSalesEvents =
  ({ venueUuid, per, page, searchFor, searchBy }) =>
  (dispatch) => {
    dispatch(fetchSalesEventsRequested())

    return api
      .fetchSalesEvents(venueUuid, per, page, searchFor, searchBy)
      .then((response) =>
        dispatch(fetchSalesEventsSucceded(response))
      )
      .catch(() => dispatch(fetchSalesEventsFailed))
  }

export const createSalesEventsRequested = () => ({
  type: CREATE_SALES_EVENTS_REQUESTED,
})

export const createSalesEventsSucceded = (payload) => ({
  type: CREATE_SALES_EVENTS_SUCCEDED,
  payload,
})

export const createSalesEventsFailed = () => ({
  type: CREATE_SALES_EVENTS_FAILED,
})

export const createSalesEvent = (data) => (dispatch) => {
  dispatch(createSalesEventsRequested())

  return api
    .createSalesEvent(data)
    .then((response) =>
      dispatch(createSalesEventsSucceded(response.data.salesEvents))
    )
    .catch(() => dispatch(createSalesEventsFailed()))
}

export const updateSalesEventsRequested = () => ({
  type: UPDATE_SALES_EVENTS_REQUESTED,
})

export const updateSalesEventsSucceded = (payload) => ({
  type: UPDATE_SALES_EVENTS_SUCCEDED,
  payload,
})

export const updateSalesEventsFailed = () => ({
  type: UPDATE_SALES_EVENTS_FAILED,
})

export const updateSalesEvent = (data) => (dispatch) => {
  dispatch(updateSalesEventsRequested())

  return api
    .updateSalesEvent(data)
    .then((response) =>
      dispatch(updateSalesEventsSucceded(response.data.salesEvents))
    )
    .catch(() => dispatch(updateSalesEventsFailed()))
}
